module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-9",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading spin-1"
  }, [_c('div', {
    staticClass: "loading spin-2"
  }, [_c('div', {
    staticClass: "loading spin-3"
  }, [_c('div', {
    staticClass: "loading spin-4"
  }, [_c('div', {
    staticClass: "loading spin-5"
  }, [_c('div', {
    staticClass: "loading spin-6"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9898ce3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Circle9.vue
// module id = 651
// module chunks = 0